import { Box } from '@mui/material'
import { Outlet } from 'react-router'
import TopBar from '../TopBar/TopBar'
import BottomNav from './BottomNav'

const TOPBAR_HEIGHT = 64
const BOTTOM_NAV_HEIGHT = 56

/**
 * Mobile layout: fixed top bar, scrollable content, fixed bottom navigation.
 */
const MobileLayout = () => (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
        <TopBar position="fixed" />
        <Box
            component="main"
            sx={{
                flexGrow: 1,
                overflow: 'auto',
                mt: `${TOPBAR_HEIGHT}px`,
                mb: `${BOTTOM_NAV_HEIGHT}px`,
            }}
        >
            <Outlet />
        </Box>
        <BottomNav />
    </Box>
)

export default MobileLayout
